import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import AgenteEditPage from '@/pages/dashboard/agente-edit-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { AGENT_CREATE_BASE_SLUGS } from '@/lib/ai-agents/agent-templates'

const agentesNovoSearchSchema = z.object({
  /** Template pronto ou `blank` (começar do zero). Sem param = seletor de base. */
  template: z.enum(AGENT_CREATE_BASE_SLUGS).optional(),
})

// Rota para criar um novo agente
// Path completo será /dashboard/$dashboardId/sistema/agentes/novo
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/agentes/novo',
)({
  validateSearch: agentesNovoSearchSchema,
  component: function AgenteNovoRoute() {
    const { dashboardId } = Route.useParams()
    const { template } = Route.useSearch()
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <AgenteEditPage
          agenteId="novo"
          dashboardId={dashboardId}
          createBase={template}
        />
      </ProtectedRoute>
    )
  },
})
